// extracted by mini-css-extract-plugin
module.exports = {"pageBanners":"style_pageBanners__2Rzafl9cV187Sh2HGl-QKb","warning":"style_warning__2ZcS-VUyINxawb7oMCddBy"};